module.exports = __webpack_public_path__ + "img/PPMP16.b79478ec.png";